import { monthEndAlertConstants } from '../../actions/constant';

const { GET_THEME_COUNT_REQUEST, GET_THEME_COUNT_SUCCESS, GET_THEME_COUNT_FAILURE } =
  monthEndAlertConstants;

const intitialstate: object = {
  response: null,
  isError: false,
  loading: false,
};

export const getThemeCountReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_THEME_COUNT_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }
    case GET_THEME_COUNT_FAILURE:
      return {
        ...state,
        isError: true,
        response: null,
        loading: false,
      };
    case GET_THEME_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        isError: false,
      };
    default:
      return state;
  }
};
